import React from 'react';
import { FileDownloadIcon } from '../../icons-new/file-download';
import IconHover from '../../icon-hover';
import { useFileDownload } from '../../../hooks/useFileDownload';
import moment from 'moment';
import { vehicleRequestConfig } from '../../../request-config/vehicle/vehicle.request-config';
import { TableParams } from '../vehicle-offers-list-component.props';

interface DownloadExcelFileProps {
  tableParams: TableParams;
}

const DownloadExcelFile = ({ tableParams }: DownloadExcelFileProps) => {
  const downloadFile = useFileDownload({
    requestConfig: vehicleRequestConfig.getReconfigurationsExcel(tableParams),
    fileName: `Mitarbeiterkonfigurationen_${moment().format('DD.MM.yyyy_HH:mm')}.xlsx`,
    encodeConfig: {
      encodeWay: 'newBlob',
      path: []
    }
  });

  return (
    <IconHover onClick={downloadFile}>
      <FileDownloadIcon width={28} height={26} />
    </IconHover>
  );
};

export default DownloadExcelFile;
